import { Component, OnInit } from '@angular/core';
import { WordpressService } from '../../../services/wordpress.service';
import { AboutOmanCard } from '../../../models/service.model';

@Component({
  selector: 'app-about-oman',
  templateUrl: './about-oman.component.html',
  styleUrls: ['./about-oman.component.scss']
})
export class AboutOmanComponent implements OnInit {
  aboutOmanItems: AboutOmanCard[] = [];
  aboutOmanLoading = true;
  aboutOmanError: string | null = null;
  aboutOmanSkeletonItems = Array.from({ length: 3 });

  constructor(private wordpressService: WordpressService) { }

  ngOnInit(): void {
    this.loadAboutOman();
  }

  private loadAboutOman(): void {
    this.wordpressService.getAboutOman().subscribe({
      next: items => {
        this.aboutOmanItems = items;
        this.aboutOmanLoading = false;
      },
      error: err => {
        this.aboutOmanError = this.formatError(err, 'Unable to fetch About Oman content from WordPress.');
        this.aboutOmanLoading = false;
      }
    });
  }

  trackByAboutOman(index: number, item: AboutOmanCard): number {
    return item.id;
  }

  private formatError(err: any, fallback: string): string {
    if (err?.status) {
      return `${err.status} ${err.statusText || 'Error'}${err.error?.message ? ' - ' + err.error.message : ''}`;
    }

    return err?.message || fallback;
  }

}
